import { render } from "./PolicyPdf.vue?vue&type=template&id=56e1ab6e"
import script from "./PolicyPdf.vue?vue&type=script&lang=js"
export * from "./PolicyPdf.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__